import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, HomeModernIcon } from '@heroicons/react/24/outline';

const AddManagedPropertyQuickAction: React.FC = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/landlord-toolkit/add-property')}
      className="w-full group flex items-center justify-between p-4 sm:p-6 bg-white border border-gray-200 rounded-xl sm:rounded-2xl shadow-sm hover:shadow-md hover:border-green-500 transition-all duration-200 text-left"
    >
      <div className="flex items-center gap-4 sm:gap-5">
        <div className="p-3 sm:p-4 bg-green-50 text-green-600 rounded-lg sm:rounded-xl group-hover:bg-green-100 transition-colors">
          <HomeModernIcon className="w-6 h-6 sm:w-8 sm:h-8" />
        </div>
        <div>
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1">Add Managed Property</h3>
          <p className="text-gray-500 text-sm sm:text-base leading-snug sm:leading-relaxed">
            Start tracking rent and managing tenants.
          </p>
        </div>
      </div>
      <div className="hidden sm:flex bg-green-600 text-white rounded-full p-2 ml-4 group-hover:bg-green-700 transition-colors">
        <PlusIcon className="w-6 h-6" />
      </div>
    </button>
  );
};

export default AddManagedPropertyQuickAction;
